'use client';

import { createContext, useContext, type ReactNode } from 'react';
import {
  STATSIG_GATE_MAP,
  type FeatureFlagName,
  type FeatureGateName,
} from './gates';

type FeatureGates = Record<FeatureGateName, boolean>;

const FeatureGateContext = createContext<FeatureGates | null>(null);

type FeatureGateProviderProps = {
  children: ReactNode;
  gates: FeatureGates;
};

export function FeatureGateProvider({
  children,
  gates,
}: FeatureGateProviderProps) {
  return (
    <FeatureGateContext.Provider value={gates}>
      {children}
    </FeatureGateContext.Provider>
  );
}

export function useFeatureFlag(flagName: FeatureFlagName): boolean {
  const gates = useContext(FeatureGateContext);

  return gates?.[STATSIG_GATE_MAP[flagName]] ?? false;
}
